import React, { FC } from 'react';
import Widget from 'shared/components/Widget';
import RecentHiringActivityChip from './recentHiringActivityChip';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IRecentHiringActivityCardData {
  name: string;
  reqId: string;
  activityName: string;
  activityStatus: string;
  date: string;
}

interface IRecentHiringActivityCard {
  id?: string;
  data: IRecentHiringActivityCardData;
}

const RecentHiringActivityCard: FC<IRecentHiringActivityCard> = ({
  id = 'hiring-activity-card',
  data: { name, reqId, activityName, activityStatus },
}) => {
  const { t } = useTranslation();
  return (
    <Widget
      sx={{ p: '0.75rem 1rem', width: '100%', borderRadius: '0.5rem' }}
      role='listitem'
      id={`${id}-widget`}
    >
      <Typography
        id={`${id}-candidate-name`}
        data-testid={`${id}-candidate-name`}
        className='kfic2-bodyText'
        title={name}
        sx={{
          mb: '0.25rem',
          textOverflow: 'initial',
          wordBreak: 'break-word',
          overflow: 'auto',
          whiteSpace: 'normal',
          width: '100%',
        }}
      >
        {name}
      </Typography>
      <Typography
        id={`${id}-candidate-activity-content`}
        data-testid={`${id}-candidate-activity-content`}
        className='kfic2-bodyText'
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography
          component='span'
          id={`${id}-candidate-activity-content-isAt`}
          data-testid={`${id}-candidate-activity-content-isAt`}
          className='kfic2-bodyText'
          sx={{
            lineHeight: '1.8125rem !important',
          }}
        >
          {`${t('isAt')} `}
        </Typography>
        <RecentHiringActivityChip
          id={`${id}-candidate-activity-name`}
          title={activityName}
          i18nKey={activityName}
        />
        {` ${t('withStatus')} `}
        <RecentHiringActivityChip
          id={`${id}-candidate-activity-status`}
          title={activityStatus}
          i18nKey={activityStatus}
        />
        {` ${t('forReq')} `}
        <RecentHiringActivityChip
          id={`${id}-candidate-activity-reqId`}
          title={reqId}
          i18nKey={reqId}
        />
      </Typography>
    </Widget>
  );
};

export default RecentHiringActivityCard;
